import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Users, Clock, ShieldAlert, ShieldX, TrendingUp } from "lucide-react";

export default function Dashboard() {
  const [kpis, setKpis] = useState(null);

  useEffect(() => {
    api.get("/dashboard/kpis").then(({ data }) => setKpis(data));
  }, []);

  const cards = kpis && [
    { label: "Live Visitors", value: kpis.live_visitors, icon: Users, testid: "kpi-live-visitors", accent: "text-brand-cyan" },
    { label: "Today's Check-ins", value: kpis.today_checkins, icon: TrendingUp, testid: "kpi-today-checkins", accent: "text-brand-cyan" },
    { label: "Avg Duration (min)", value: kpis.avg_duration_minutes, icon: Clock, testid: "kpi-avg-duration", accent: "text-slate-400" },
    { label: "Watchlist Hits Today", value: kpis.watchlist_hits_today, icon: ShieldAlert, testid: "kpi-watchlist-hits", accent: "text-amber-500" },
    { label: "Blacklist Hits Today", value: kpis.blacklist_hits_today, icon: ShieldX, testid: "kpi-blacklist-hits", accent: "text-red-600" },
  ];

  return (
    <div className="p-8 space-y-8" data-testid="dashboard-page">
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-cyan">Overview</span>
        <h1 className="text-3xl font-bold uppercase tracking-tight mt-1 text-brand-navy">Dashboard</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {cards?.map((c) => (
          <div key={c.label} data-testid={c.testid} className="border border-slate-200 bg-white p-6">
            <c.icon className={`mb-3 ${c.accent}`} size={24} />
            <p className="text-3xl font-black text-brand-navy">{c.value ?? "-"}</p>
            <p className="text-xs uppercase tracking-widest text-slate-400 mt-2">{c.label}</p>
          </div>
        ))}
      </div>
      <div className="border border-slate-200 bg-white p-6">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Top Hosts</span>
        <div className="mt-4 space-y-2">
          {kpis?.top_hosts?.length ? (
            kpis.top_hosts.map((h) => (
              <div key={h.name} className="flex justify-between border-b border-slate-100 py-2 text-sm">
                <span className="text-slate-700">{h.name}</span>
                <span className="font-bold text-brand-navy">{h.count}</span>
              </div>
            ))
          ) : (
            <p className="text-sm text-slate-400">No data yet</p>
          )}
        </div>
      </div>
    </div>
  );
}
